/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/24/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Splashscreen = Tc.Module.extend({

        on: function (callback) {
            var $ctx = this.$ctx;

            $(window).resize(function() {
                $ctx.height($(window).height());
            });
            
            $ctx.height($(window).height());

            $('.js-splashscreen-close', $ctx).on('click', function() {
                $("html, body").animate({ scrollTop: $(window).height() }, 800);
                $ctx.css('z-index','4000');
            });

            callback();
        }
    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Splashscreen.js
// module id = 45
// module chunks = 0